module.exports = __webpack_public_path__ + "static/course3-a1ce0bbd14877b6ba15dce3c08acb179.jpg";